// extracted by mini-css-extract-plugin
export default {"switch":"iosToggle_switch__B8Ww8","slider":"iosToggle_slider__DRh7a","disabled":"iosToggle_disabled__KXSkV"};